import { Box, chakra, Text } from '@stockx/ui';

export const StyledModalImageContainer = chakra(Box, {
  baseStyle: {
    position: 'absolute',
    bottom: 0,
    zIndex: 100,
    px: { base: 1, md: 0 },
    transform: 'rotate(-180deg)',
    backgroundColor: 'beige.300',
  },
});

export const StyledModalImageLabel = chakra(Text, {
  baseStyle: {
    p: { base: '6px 11px 9px 10px', xl: '8px 4px 12px 4px' },
  },
});

export const StyledModalImageLabelText = chakra(Text, {
  baseStyle: {
    fontSize: { base: 'xs', md: 'sm' },
  },
});

export const StyledModalProductsQuantityLabel = chakra('span', {
  baseStyle: {
    ml: 1,
    fontSize: 'sm',
    fontWeight: 400,
    color: 'grey.700',
  },
});

export const StyledModalSocialWrapper = chakra('ul', {
  baseStyle: {
    display: 'flex',
    listStyleType: 'none',
    wrap: 'nowrap',
    alignItems: 'center',
    position: 'absolute',
    bottom: 2,
    right: 0,
    mr: '2%',
    a: {
      backgroundColor: 'transparent',
      paddingX: '0.5rem',
    },
  },
});

const baseModalArrowStylesDesktop = {
  position: 'absolute',
  top: '50%',
  zIndex: 1,
  color: 'white',
  cursor: 'pointer',
};

const baseModalArrowStylesMobile = {
  position: 'absolute',
  top: '45%',
  zIndex: 1,
  color: 'black',
  background: 'white',
  cursor: 'pointer',
  padding: '13px 9px',
};

export const StyledModalArrowStyles = {
  variants: {
    left: {
      ...baseModalArrowStylesDesktop,
      left: '-3rem',
    },
    right: {
      ...baseModalArrowStylesDesktop,
      right: '-3rem',
    },
    leftMobile: {
      ...baseModalArrowStylesMobile,
      left: 0,
    },
    rightMobile: {
      ...baseModalArrowStylesMobile,
      right: 0,
    },
  },
};

const baseModalImageContainerStyles = {
  pl: { base: 1, md: 0 },
  pr: { base: 1, md: 0 },
  backgroundColor: 'beige.300',
  position: 'absolute',
  bottom: 0,
  zIndex: 100,
};

export const StyledModalImageContainerStyles = {
  variants: {
    mobile: {
      ...baseModalImageContainerStyles,
      transform: 'rotate(0deg)',
    },
    desktop: {
      ...baseModalImageContainerStyles,
      transform: 'rotate(-180deg)',
    },
  },
};
